export default "__VITE_ASSET__DCQRfxpY__"